<template>
	<div>
		<el-row>

			<el-col :offset="3" :span="19" :title="'网站今日访问量:'+reqCount">

				<img src="https://qq-gjx.oss-cn-shanghai.aliyuncs.com/pc/logo.png" height="100"
					style="margin-top: -15px;" />

			</el-col>

			<el-col :span="2">

				<el-dropdown>
					<span class="el-dropdown-link">
						<el-image style="width: 40px; height: 40px" :src="userInfo.headUrl"></el-image> &nbsp;<span
							style="position: relative; bottom: 10px;">{{userInfo.nickname}}</span>
					</span>
					<el-dropdown-menu slot="dropdown">
						<span @click="openMyInfo()"><el-dropdown-item>我的信息</el-dropdown-item></span>
						<span @click="openComment()"><el-dropdown-item>我的评论</el-dropdown-item></span>
						<span @click="openWebsite()"><el-dropdown-item>我提交的站点</el-dropdown-item></span>
						<span @click="openWebsiteAdd()"><el-dropdown-item>提交站点</el-dropdown-item></span>
						<span @click="openAboutUs()"><el-dropdown-item>关于我们</el-dropdown-item></span>
									<!-- <span @click="openUserSign()"><el-dropdown-item>签到</el-dropdown-item></span> -->
						<span @click="openGitee()"><el-dropdown-item>站长gitee</el-dropdown-item></span>
						<span @click="logout()"><el-dropdown-item >退出登录</el-dropdown-item></span>

					</el-dropdown-menu>
				</el-dropdown>

			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<el-menu :default-active="activeIndex" background-color="#ffffff" text-color="#8f8f8f"
					active-text-color="#0055ff" class="flex" mode="horizontal" @select="handleSelect">

					<el-menu-item class="flex-item" :index="(index+1).toString()" v-for="(menu,index) in menuList"
						:key="menu.id">{{menu.name}}</el-menu-item>

				</el-menu>
			</el-col>

		</el-row>


		<br />

<div v-loading="contentLoading">
		<router-view :menuId="(menuList[activeIndex-1].id).toString()" :home="my"></router-view>
</div>
<!-- 个人信息-->
		<el-dialog title="我的信息" :visible.sync="dialogMyInfo" :close-on-click-modal='false'>
			<div class="personal-info">
				<div class="avatar">
					<el-upload class="upload-demo" :action="uploadUrl" :headers="headers" :show-file-list="false"
						:on-success="uploadSuccess" :limit="1">
						<img :src="userInfo.headUrl" alt="Avatar">
					</el-upload>
				</div>
				<el-form ref="infoForm" :model="userInfo" label-width="80px">
					<el-form-item label="昵称">
						<el-input v-model="userInfo.nickname"></el-input>
					</el-form-item>
				
					<el-form-item label="收货地址">
						<el-input v-model="userInfo.address" placeholder="收货地址/支付宝账号" ></el-input>
					</el-form-item>
					<el-form-item label="手机号码">
						<el-input v-model="userInfo.phone"></el-input>
					</el-form-item>
					
					<el-form-item label="上次登录">
						<el-input v-model="userInfo.lastPcLoginTime" disabled></el-input>
					</el-form-item>
					<el-form-item label="创建时间">
						<el-input v-model="userInfo.createTime" disabled></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="updateUserInfo()">更新信息</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
		
		<el-dialog title="我的评论" :visible.sync="dialogComment" :close-on-click-modal='false'
	>
	  <div>
	    <el-table :data="commentTableData" style="width: 100%">
	      <el-table-column prop="content" label="内容"></el-table-column>
	      <el-table-column prop="likesCount" label="点赞次数"></el-table-column>
	      <el-table-column  label="审核状态">  <template slot-scope="scope">
    <!-- scope.row 包含当前行的数据 -->
    <span>{{ scope.row.status==1?'审核通过':'' }}
	{{ scope.row.status==0?'未审核':'' }}
	{{ scope.row.status==2?'已拒绝':'' }}</span>
  </template></el-table-column>
  
  <el-table-column  label="拒绝信息"> 
   <template slot-scope="scope">
    {{ scope.row.rejectText }}

  </template></el-table-column>
	 <el-table-column prop="createTime" label="发布时间"></el-table-column>

		</el-table>
	
	    <el-pagination
	      @size-change="handleCommentSizeChange"
	      @current-change="handleCommentCurrentChange"
	      :current-page="currentPageComment"
	      :page-sizes="[5]"
	      :page-size="pageSizeComment"
	      layout="total, sizes, prev, pager, next, jumper"
	      :total="totalComment"
	    ></el-pagination>
	  </div>
		</el-dialog>
		
		<!-- 表单弹出框 -->
		   <el-dialog
		     title="添加站点"
		     :visible.sync="dialogWebsiteAdd"
		     width="30%"
			 :close-on-click-modal='false'
		     @close="resetWebsiteAddForm"
		   >
		     <el-form :model="websiteAddForm" ref="formData" label-width="80px">
		       <el-form-item label="站点名称">
		         <el-input v-model="websiteAddForm.name"></el-input>
		       </el-form-item>
		       <el-form-item label="站点URL">
		         <el-input v-model="websiteAddForm.url"></el-input>
		       </el-form-item>
		     </el-form>
		     <span slot="footer" class="dialog-footer">
		       <el-button @click="closeWebsiteAddDialog()">取消</el-button>
		       <el-button type="primary" @click="addMyWebSite()">提交</el-button>
		     </span>
		   </el-dialog>
		
		<el-dialog title="我提交的站点" :visible.sync="dialogWebsite" :close-on-click-modal='false'
			>
			  <div>
				  
				  
					  
			
					  
			
			    <el-table :data="websiteTableData" style="width: 100%">
			      <el-table-column prop="name" label="站点名称"></el-table-column>
			      <el-table-column prop="url" label="url"></el-table-column>
			      <el-table-column  label="审核状态">  <template slot-scope="scope">
		  <!-- scope.row 包含当前行的数据 -->
		  <span>{{ scope.row.status==1?'审核通过':'' }}
			{{ scope.row.status==0?'未审核':'' }}
	</span>
		</template></el-table-column>
		
		<el-table-column  label="回复信息"> 
		 <template slot-scope="scope">
		  {{ scope.row.remark }}
		
		</template></el-table-column>
			 <el-table-column prop="createTime" label="提交时间"></el-table-column>
		
				</el-table>
			
			    <el-pagination
			      @size-change="handleWebsiteSizeChange"
			      @current-change="handleWebsiteCurrentChange"
			      :current-page="currentPageWebsite"
			      :page-sizes="[5]"
			      :page-size="pageSizeWebsite"
			      layout="total, sizes, prev, pager, next, jumper"
			      :total="totalWebsite"
			    ></el-pagination>
			  </div>
				</el-dialog>
				
				
				<el-dialog
				      title="关于我们"
				      :visible.sync="dialogAboutUs"
				      width="400px"
				     :close-on-click-modal='false'
				    >
				      <h3>开发者</h3>
					  <p>**迁(IT_迁哥)</p>
					  <!-- <p>**杰</p> -->
					    <br/>
						  <p>以上排名不分先后</p>
				    </el-dialog>
					
					<el-dialog
					      title="签到"
					      :visible.sync="dialogUserSign"
					     :close-on-click-modal='false'
					    >
						
					 <div class="container" v-loading="signLoading">
					    <el-row>
					      <el-col :span="12" class="text-right">
					        <h3>累积签到天数：{{ totalDays }}</h3>
					      </el-col>
					
					    </el-row>
					
					    <el-row>
					      <el-col :span="18">
					        <h3>签到排名前10名：</h3>
					        <div class="rank-list">
					          <div v-for="(user, index) in users" :key="user.userId" class="rank-item">
					            <span class="rank">{{ index + 1 }}.</span>
					            <span class="name">{{ user.nickname }}</span>
					            <span class="days">({{ user.dayCount }} 天)</span>
					          </div>
					        </div>
					      </el-col>
						  <el-col :span="6">
						    <el-button class="sign-button" @click="sign()" :disabled="isSignedIn">签到</el-button>
						  </el-col>
					    </el-row>
					
					    <el-row>
					      <el-col :span="24">
					        <h3>活动公告</h3>
					        <div class="announcement">{{ announcement }}</div>
					      </el-col>
					    </el-row>
					  </div>
							    </el-dialog>
						
						
	</div>
	
</template>

<script>
	export default {
		name: 'home',
		components: {

		},
		data() {
			return {
				title: 'home',
				my:{},
				contentLoading:false,
				dialogMyInfo: false,
			     dialogComment: false,
				      dialogWebsite: false,
					  dialogWebsiteAdd:false,
					  dialogAboutUs:false,
					  dialogUserSign:false,
					  websiteAddForm:{
						  name:"",
						  url:""
					  },
					  
				url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
				activeIndex: "1",
				userInfo: {},

				menuList: [



				],
				reqCount: 0,
				uploadUrl: "",
				headers: {},
				      commentTableData: [

				      ],
				      currentPageComment: 1, // 当前页数
				      pageSizeComment: 5, // 每页显示的条数
					  totalComment:0,
					  
					  websiteTableData: [

					  				    
					  ],
					  currentPageWebsite: 1, // 当前页数
					  pageSizeWebsite: 5, // 每页显示的条数
					  totalWebsite:0,
					  signLoading:false,
					       isSignedIn: false, // 是否已签到
					        totalDays: 0, // 累积签到天数
					        users: [
					    
			
					        ],
					        announcement: '本活动长期有效，每年重置签到次数，'+
							'年底签到第一名300,第二名200，第三名100(相同按签到时间决定)请务必在我的信息更新手机号码和收货地址，以确保奖品正常发放！(恶意刷签到会被取消资格)',
			}
		},
		methods: {
			    signIn() {
			      // 执行签到逻辑，可以在这里更新数据库或其他操作
			      this.isSignedIn = true;
			      this.totalDays++;
			      // 更新当前用户的签到天数
			      // 比如：
			      // const currentUser = this.users.find(user => user.id === currentUserId);
			      // currentUser.days++;
			
			      // 注意：以上代码仅为示例，需要根据实际情况进行修改
			    },
			logout(){
				this.$api.logout().then(res=>{
					localStorage.removeItem("token")
					this.$router.push('/')
				})
				
			},
			resetWebsiteAddForm(){
				this.websiteAddForm.name=""
				this.websiteAddForm.url=""
			},
			closeWebsiteAddDialog(){
				this.dialogWebsiteAdd=false
			},
			addMyWebSite(){
				if(this.websiteAddForm.name==""){
					this.$notify({
						title: '消息提示',
						message: "网站名称不要为空！",
						type: 'error'
					});
					return
				}
		
				if(this.websiteAddForm.url==""){
					this.$notify({
						title: '消息提示',
						message: "网站url不要为空！",
						type: 'error'
					});
					return
				}
				
				if(this.websiteAddForm.name.length>15){
					this.$notify({
						title: '消息提示',
						message: "网站名称长度不要大于15",
						type: 'error'
					});
					return
				}
				if(this.websiteAddForm.url.length>200){
					this.$notify({
						title: '消息提示',
						message: "url长度不要大于200",
						type: 'error'
					});
					return
				}
				this.$api.saveUserWebsite({name:this.websiteAddForm.name,url:this.websiteAddForm.name,userId:
				this.userInfo.id}).then(res=>{
					if(res.data.code==200){
						this.$notify({
							title: '消息提示',
							message: "提交成功,等待管理员审核！",
							type: 'success'
						});
					this.dialogWebsiteAdd=false
					}else{
						this.$notify({
							title: '消息提示',
							message: res.data.msg,
							type: 'error'
						});
					}
				})
				
			},
			loadMyComment(){
					this.$api.getCommentPage({page:this.currentPageComment,limit:this.pageSizeComment,
					userId:this.userInfo.id}).then(res=>{
						this.commentTableData=res.data.data
						this.totalComment=res.data.total
					})
			},
			loadWebsite(){
					this.$api.getUserWebsitePage({page:this.currentPageWebsite,limit:this.pageSizeWebsite,
					userId:this.userInfo.id}).then(res=>{
						this.websiteTableData=res.data.data
						this.totalWebsite=res.data.total
					})
			},
			    handleCommentSizeChange(val) {
			      this.pageSizeComment = val; // 用户改变每页显示条数时触发
			    },
			
			    handleCommentCurrentChange(val) {
			      this.currentPageComment = val; // 用户改变当前页数时触发
			    this.loadMyComment()
				},
				handleWebsiteSizeChange(val) {
				  this.pageSizeWebsite = val; // 用户改变每页显示条数时触发
				},
							
				handleWebsiteCurrentChange(val) {
				  this.currentPageWebsite = val; // 用户改变当前页数时触发
				this.loadWebsite()
				},
			handleSelect(key, keyPath) {

				console.log(key, keyPath);
				this.activeIndex = key
				this.$router.push(this.menuList[key - 1].path)
			},
			openMyInfo() {
				console.log('---open---')
				this.dialogMyInfo = true
			},
			openComment() {
				console.log('---open---')
				this.currentPageComment=1
				this.dialogComment = true
				this.loadMyComment()
			},
			openWebsite() {
				console.log('---open---')
				this.currentPageWebsite=1
				this.dialogWebsite = true
				this.loadWebsite()
			},
			openWebsiteAdd(){
				this.dialogWebsiteAdd=true;
			},
			openAboutUs(){
				this.dialogAboutUs=true
			},
			openGitee(){
					window.open('https://api.gitee.com/black_d/','_blank')
			},
			openUserSign(){
				this.dialogUserSign=true
				this.checkSign()
				this.loadSignTop10()
				this.signCount()
			},
			uploadSuccess(res, file, fileList) {
				console.log(fileList)
				fileList.splice(0, fileList.length)
				console.log(res)
				this.userInfo.headUrl = res.data
			},
			updateUserInfo() {
				if(this.userInfo.nickname==""){
					this.$notify({
						title: '消息提示',
						message: "昵称不要为空！",
						type: 'error'
					});
					return
				}
				
				if(this.userInfo.nickname.length>15){
					this.$notify({
						title: '消息提示',
						message: "昵称长度不要大于15",
						type: 'error'
					});
					return
				}
				
				if(this.userInfo.phone!=undefined&&this.userInfo.phone.length>15){
					this.$notify({
						title: '消息提示',
						message: "电话长度不要大于15",
						type: 'error'
					});
					return
				}
				
				if(this.userInfo.address!=undefined&&this.userInfo.address.length>200){
					this.$notify({
						title: '消息提示',
						message: "收货地址长度不要大于200",
						type: 'error'
					});
					return
				}
				this.$api.updateBaseUserInfo(this.userInfo).then(res => {
					if (res.data.code == 200) {
						this.$notify({
							title: '消息提示',
							message: "操作成功!",
							type: 'success'
						});
						this.$api.getUserInfo().then(res => {
							this.userInfo = res.data.data
							localStorage.setItem("userInfo", JSON.stringify(this.userInfo))
						this.dialogMyInfo = false
						})

					} else {
						this.$notify({
							title: '消息提示',
							message: res.data.msg,
							type: 'error'
						});
					}
				})
			},
			loadSignTop10(){
				this.$api.getTop10().then(res=>{
					this.users=res.data.data
				})
			},
			checkSign(){
				this.$api.checkUserSign().then(res=>{
					this.isSignedIn= res.data.data
				})
			},
			sign(){
				this.signLoading=true
				this.$api.saveUserSign().then(res=>{
					if(res.data.data){
						this.$notify({
							title: '消息提示',
							message: "操作成功!",
							type: 'success'
						});
						this.checkSign()
						this.loadSignTop10()
						this.signCount()
					}else{
						this.$notify({
							title: '消息提示',
							message: "未知错误!",
							type: 'error'
						});
					}
					this.signLoading=false
				})
			},
			signCount(){
				this.$api.getUserSignCount().then(res=>{
					this.totalDays= res.data.data
				})
			}
		},
		mounted() {
	// this.$notify({
	// 	title: '签到奖励通知',
	// 	message: '1：马上就到年底了，派发奖励了<br/>' +
	// 		'2：请符合奖项的用户填写基础资料，站长会发送奖励物品或者现金<br/>' +
	// 		'3：未及时填写的视为放弃奖励，有疑问加站长qq:1311168011<br/>' +
	// 		'4：2024年的奖励会更新，前三名都有奖励(可以并列)！<br/>'+
	// 			'5：感谢本网站的赞助者！<br/>',
	// 	dangerouslyUseHTMLString: true,
	// 	duration: 30000,
	// 	type: 'warning'
	// });
			
			this.my=this;
			this.uploadUrl = this.$common.BASE_URL + '/pc/uploadHeadUrl'
			this.headers.token = localStorage.getItem("token")
			this.$router.push({
				path: '/tool'

			})
			this.$api.requestCountByDay().then(res => {
				this.$api.getRequestCount().then(res2 => {
					this.reqCount = res2.data.data
				})

			})
			this.$api.getUserInfo().then(res => {
				this.userInfo = res.data.data
				localStorage.setItem("userInfo", JSON.stringify(this.userInfo))
			})
			this.$api.getMenu().then(res => {
				this.menuList = res.data.data
			})
		}
	}
</script>

<style>
	.el-menu {
		display: flex;
		justify-content: center;
	}

	.el-menu-item {
		text-align: center;
	}

	.nickname {
		font-size: 16px;
		line-height: 40px;
		vertical-align: middle;
	}

	.grid-logo {
		width: 100%;
		height: 100px;
		object-fit: contain;
		margin-bottom: 10px;
	}

	.grid-info {
		padding: 10px;
		text-align: center;
	}

	.grid-title {
		font-size: 16px;
		margin-bottom: 10px;
	}

	.grid-description {
		font-size: 14px;
		color: #999;
		line-height: 22px;
	}

	/* .el-card {
  margin-top: 20px;
} */
	.personal-info {
		display: flex;
		align-items: center;
	}

	.avatar img {
		width: 80px;
		height: 80px;
		border-radius: 50%;
	}

	.el-form-item__label {
		font-weight: bold;
	}
 .container {
   max-width: 400px;
   margin: 0 auto;
   padding: 20px;
 }
 
 .sign-button {
   margin-bottom: 20px;
 }
 
 .rank-list,
 .announcement {
   margin-bottom: 20px;
 }
 
 .rank-list li {
   margin-bottom: 8px;
 }
 
 .rank {
   margin-right: 8px;
   font-weight: bold;
 }
 
 .name {
   margin-right: 12px;
 }
 
 .days {
   font-weight: bold;
 }
 
 .homeFrame{
	 border: none;
 }
</style>
